import Table from "../../../components/table/table";
import { FaCheckSquare } from "react-icons/fa";
import { FaSquareXmark } from "react-icons/fa6";
import { FaCircle } from "react-icons/fa";
import Button from "../../../components/buttons/button";

const EmployeeAttendance = ({ t }) => {
  const employees = [
    {
      date: "05/06/2023",
      timeIn: "-",
      timeOut: "-",
      status: "late",
    },
    {
      date: "05/06/2023",
      timeIn: "08:02",
      timeOut: "17:05",
      status: "present",
    },
    {
      date: "05/06/2023",
      timeIn: "-",
      timeOut: "-",
      status: "absent",
    },
    {
      date: "05/06/2023",
      timeIn: "08:10",
      timeOut: "17:00",
      status: "present",
    },
    {
      date: "05/06/2023",
      timeIn: "-",
      timeOut: "-",
      status: "vacation",
    },
  ];
  const tableHead = [
    {
      header: t("date"),
      accessorKey: "date",
    },
    {
      header: t("status"),
      accessorKey: "status",
    },
    {
      header: t("attendanceTime"),
      accessorKey: "attendanceTime",
    },
    {
      header: t("leaveTime"),
      accessorKey: "leaveTime",
    },
  ];
  const tableData = employees.map((m, i) => {
    const icon =
      m.status === "present" ? (
        <FaCheckSquare className="text-[#11A849]" />
      ) : m.status === "absent" ? (
        <FaSquareXmark className="text-[#902929]" />
      ) : m.status === "late" ? (
        <FaCircle className="text-[#FB923C]" />
      ) : (
        <FaCircle className="text-[#3C7CFB]" />
      );
    const status = (
      <span className="flex items-center justify-center w-full gap-2">
        {icon}
        {t(m.status)}
      </span>
    );

    return {
      date: m.date,
      attendanceTime: m.timeIn,
      leaveTime: m.timeOut,
      status,
    };
  });
  return (
    <section className="grid">
      <div className="flex items-center p-4 border border-primary rounded-xl">
        <p className="w-full">
          <span className="font-medium text-primary">{t("job")}: </span>
          <span className="font-semibold">مسؤول مخزن</span>
        </p>
        <p className="w-full">
          <span className="font-medium text-primary">{t("department")}: </span>
          <span className="font-semibold">المخزن</span>
        </p>
      </div>
      <Table TableData={tableData} TableHead={tableHead} tableStyle="min-w-[400px]" />
      <Button className={"rtl:mr-auto ltr:ml-auto bg-primary text-black"}>
        {t("close")}
      </Button>
    </section>
  );
};

export default EmployeeAttendance;
